// Zoe — Sleepy Trouble Bubble: lobs a sleep bubble at a random enemy.
// The target falls asleep for 2 turns (cannot act). Any damage wakes them.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const zoeSleepyTrouble: Ability = {
  id: "zoeSleepyTrouble",
  displayName: "Sleepy Trouble Bubble",
  description: "Puts a random enemy to sleep for 2 turns and deals 0.6× AP + 30 magic damage. They wake if damaged.",
  iconId: "ZoeE",

  targetShape({ caster, combat }) {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(enemyTeam);
    if (enemies.length === 0) return [];
    const target = enemies[Math.floor(Math.random() * enemies.length)];
    return [target.pos];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(enemyTeam);
    if (enemies.length === 0) return [];
    const target = enemies[Math.floor(Math.random() * enemies.length)];
    const stats = effectiveStats(caster);
    return [{
      target,
      amount: magicDamage(stats.ap * 0.6 + 33),
      type: "magical",
      effect: { kind: "sleep", duration: 2 },
    }];
  },
};
